var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"architecture box",style:(_vm.val.backgroundImg)},[_c('p',[_vm._v(_vm._s(_vm.val.name))]),_c('v-img',{staticClass:"img",attrs:{"attachment-id":_vm.val.img,"default-img":require('@/assets/img/kctp.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }